import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, asset } from "@/lib/api";

export default function Home() {
  const [builders, setBuilders] = useState([]);
  useEffect(() => {
    api.get("/public/builders").then((r) => setBuilders(r.data));
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <section className="relative overflow-hidden grain">
        <img src="/seed/ext2.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/85 via-slate-950/55 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-28 sm:py-40 text-white">
          <p className="text-xs uppercase tracking-[0.3em] text-amber-200/90 rise">New homes, explored in 3D</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold max-w-2xl mt-5 leading-tight rise" style={{ animationDelay: ".1s" }}>
            Walk through your next home before it's yours.
          </h1>
          <p className="mt-6 max-w-xl text-white/80 text-base rise" style={{ animationDelay: ".2s" }}>
            Explore developments, choose a lot, step inside the show home and personalise every finish.
          </p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <h2 className="font-serif text-3xl font-semibold mb-10">Our developments</h2>
        <div className="grid gap-8 md:grid-cols-2">
          {builders.flatMap((b) => b.developments.map((d, i) => (
            <Link key={d.id} to={`/d/${d.id}`} className="group block rounded-3xl overflow-hidden bg-white shadow-[0_10px_30px_-5px_rgba(15,23,42,0.08)] hover:shadow-[0_20px_40px_-10px_rgba(15,23,42,0.18)] transition-shadow duration-300 rise" style={{ animationDelay: `${i * 0.08}s` }} data-testid={`home-development-card-${d.id}`}>
              <div className="aspect-[16/10] overflow-hidden">
                <img src={asset(d.hero_url || d.site_plan_url)} alt={d.name} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" />
              </div>
              <div className="p-6 flex items-end justify-between gap-4">
                <div>
                  <p className="text-xs uppercase tracking-widest text-slate-500">{b.name}</p>
                  <h3 className="font-serif text-2xl mt-1">{d.name}</h3>
                  <p className="text-sm text-slate-500 mt-1">{d.location}</p>
                </div>
                <ArrowUpRight className="w-6 h-6 text-slate-400 group-hover:text-slate-900 transition-colors" />
              </div>
            </Link>
          )))}
          {builders.filter((b) => b.developments.length === 0).map((b) => (
            <Link key={b.id} to={`/b/${b.slug}`} className="group rounded-3xl bg-white p-8 shadow-[0_10px_30px_-5px_rgba(15,23,42,0.08)] hover:shadow-xl transition-shadow flex items-end justify-between" data-testid={`home-builder-card-${b.slug}`}>
              <div><p className="text-xs uppercase tracking-widest text-slate-500">Builder</p><h3 className="font-serif text-2xl mt-1">{b.name}</h3><p className="text-sm text-slate-500 mt-1">{b.tagline || "Explore our homes in 3D"}</p></div>
              <ArrowUpRight className="w-6 h-6 text-slate-400 group-hover:text-slate-900 transition-colors" />
            </Link>
          ))}
        </div>
        <div className="mt-16 flex flex-wrap gap-3">
          {builders.map((b) => (
            <Link key={b.id} to={`/b/${b.slug}`} className="text-sm underline underline-offset-4 text-slate-600 hover:text-slate-900" data-testid={`home-builder-link-${b.slug}`}>
              All homes by {b.name}
            </Link>
          ))}
        </div>
      </section>
      <footer className="border-t py-8 text-center text-xs text-slate-400">
        <Link to="/admin/login" data-testid="footer-admin-link">Login</Link>
      </footer>
    </div>
  );
}
